module.exports = __webpack_public_path__ + "media/images/icons/tree-355449896e72c8151803360a511cd8d4.svg";